export enum RichTextEditorFormat {
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  bold = 'bold',
  listBullet = 'listBullet',
  listOrdered = 'listOrdered',
  link = 'link',
  showMoreHr = 'showMoreHr',
}

export type TRichTextEditorFormat = keyof typeof RichTextEditorFormat;
